import moment from 'moment';
import React, { useState } from 'react';

const defaultValue = {
  notasFiscais: [],
  loading: false,
  selecao: [],
  data: moment(new Date()).format('YYYY-MM-DD'),
  search: '',
  tipoSelecao: 'NENHUM',
  somatorios: {},
  totalElements: 0,
  page: 0,
  size: 15,
  sort: 'dataEmissaoNf,DESC',
  modal: '',
  notaDevolucao: { operacao: 'VENDA', chaveAcesso: '' },
  notaRemessa: {},
  atualizarGrid: false,
  filtroAvancado: {},
};

export const NotaFiscalContext = React.createContext({});

export const NotaFiscalProvider = (props) => {
  return (
    <NotaFiscalContext.Provider
      value={{
        notasFiscais: useState(defaultValue.notasFiscais),
        loading: useState(defaultValue.loading),
        selecao: useState(defaultValue.selecao),
        data: useState(defaultValue.data),
        search: useState(defaultValue.search),
        somatorios: useState(defaultValue.somatorios),
        totalElements: useState(defaultValue.totalElements),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
        modal: useState(defaultValue.modal),
        notaDevolucao: useState(defaultValue.notaDevolucao),
        notaRemessa: useState(defaultValue.notaRemessa),
        atualizarGrid: useState(defaultValue.atualizarGrid),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        filtroAvancado: useState(defaultValue.filtroAvancado),
      }}
    >
      {props.children}
    </NotaFiscalContext.Provider>
  );
};

export const NotaFiscalConsumer = NotaFiscalContext.Consumer;
